utils = {};

utils.common = {
  actionVideo: function ($video, action) {
    if ($video.length) {
      // Check if iframe has a vimeo or youtube video
      if ($video.data("platform") === "vimeo") {
        // VIMEO
        let videoID = $video.attr("id");
        let vimeoPlayer = document.getElementById(videoID);

        var player = new Vimeo.Player(vimeoPlayer);
        if (action === "play") {
          player.play();
        } else if (action === "pause") {
          player.pause();
        }
      } else {
        // YOUTUBE
        $video[0].contentWindow.postMessage(
          '{"event":"command","func":"' + action + '","args":""}',
          "*"
        );
      }

      $("body").focus();
      $("body").select();
    }
  },
  validateEmail: function (email) {
    let validEmail =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return validEmail.test(String(email).toLowerCase());
  },
  checkForm: function (form) {
    let validationForm = {};

    validationForm.valid = true;
    validationForm.message = "";

    // Check if required fields are not empty
    $(form)
      .find("[required]")
      .each((index, item) => {
        let $item = $(item);
        let itemName;

        if ($item.data("label")) itemName = $item.data("label");
        else if ($item.siblings(".label").text())
          itemName = $item.siblings(".label").text();
        else itemName = "";

        itemName = $.trim(itemName.replace("*", "")).toUpperCase();
        if (
          ($item.is('input[type="text"]') && $.trim($item.val()) === "") ||
          ($item.is("select") && $item.val() === "default") ||
          ($item.is('input[type="checkbox"]') && !$item.is(":checked")) ||
          ($item.is('input[type="file"]') && $.trim($item.val()) === "")
        ) {
          $item.addClass("error");
          validationForm.valid = false;
          validationForm.message +=
            "- " +
            itemName +
            " " +
            Lang.get("common/forms.compulsory_field") +
            "\n";
        } else if (
          $item.is('input[type="email"]') &&
          !utils.common.validateEmail($item.val())
        ) {
          $item.addClass("error");
          validationForm.valid = false;
          validationForm.message +=
            "- " +
            itemName +
            " " +
            Lang.get("common/forms.must_have_format") +
            "\n";
        }
      });

    return validationForm;
  },
};

utils.header = {
  init: function () {},

  binds: function () {
    $(".js-toggleWebGroup").on("click", this.toggleWebGroup);
    $(".js-toggleLanguages").on("click", this.toggleLanguages);
    $(".js-MenuLink").on("click", this.toggleMenuLink);
    $(".js-openMenuXS").on("click", this.openMenuXS);
    $(".js-MenuLinkXS").on("click", this.toggleMenuLinkXS);
    $(".js-changeLanguage").on("click", this.toggleChangeLanguage);
    $(".js-toggleFinder").on("click", this.toggleFinder);
    $(".js-openFinderXS").on("click", this.toggleFinderXS);
    $(".js-doSearch").on("click", this.executeSearch);
    $(".js-searchInput").on("keydown", this.executeSearch);
    $(".js-expandSearch").on("click", this.toggleResults);
    $(".js-toggleSubmenu").on("click", this.toggleSubmenu);
    $(".js-popupSubmenu").on("click", this.popupSubmenu);
        $(document).on("mousedown", this.checkInsideSubmenu);

  },

  checkInsideSubmenu: function (e) {
    let $submenuOpen = $(".submenu-item.show");
    let $menuActive = $('.menu-item.show');

    if ($submenuOpen.length > 0) {
      let id = $submenuOpen.data("id");
      if (
        !$submenuOpen.is(e.target) && $submenuOpen.has(e.target).length === 0 &&
        !$menuActive.is(e.target) && $menuActive.has(e.target).length === 0
      ) {
        let $submenuWrapper = $(".menu-item[data-id=" + id + "]");
        $submenuOpen.removeClass("show");
        $submenuWrapper.removeClass("show");
      }
    }
  },

  toggleWebGroup: function () {
    let $webWrapper = $("#webs");
    let $layoutWebWrapper = $(".header-webs-layout");

    if ($webWrapper.hasClass("show")) {
      $webWrapper.removeClass("show");
      $layoutWebWrapper.removeClass("show");
      $("body").removeClass("no-scroll");
    } else {
      $("body").addClass("no-scroll");
      $webWrapper.addClass("show");
      $layoutWebWrapper.addClass("show");
    }
  },

  toggleLanguages: function () {
    let $languageWrapper = $("#language-list");
    if ($languageWrapper.hasClass("show")) {
      $(this).removeClass("open");
      $languageWrapper.removeClass("show");
    } else {
      $(this).addClass("open");
      $languageWrapper.addClass("show");
    }
  },

  hasScrolled: function () {
    var st = $("html").scrollTop();
    console.log("hasScrolled");

    // Make sure they scroll more than delta
    if (Math.abs(utils.scroll.lastScrollTop - st) <= utils.scroll.delta) return;

    if (st < 10) {
      $(".top-bar").removeClass("hidden");
    } else {
      $(".top-bar").addClass("hidden");
    }

    if (st > utils.scroll.lastScrollTop && st > utils.scroll.navbarHeight) {
      $("#main-header").removeClass("nav-down").addClass("nav-up");
      $(".submenu-item.show").removeClass("show");
      $(".menu-item.show").removeClass("show");
    } else {
      if (st + $(window).height() < $(document).height()) {
        $("#main-header").removeClass("nav-up").addClass("nav-down");
      }
    }

    utils.scroll.lastScrollTop = st;
  },

  toggleChangeLanguage: function () {
    $(this).siblings().removeClass("is-active");
    $(this).addClass("is-active");
    // TODO CHANGE REAL
  },

  toggleMenuLink: function () {
    let $currentOpen = $(".menu-item.show");
    let $menuItems = $(".js-MenuLink");
    console.log($(this), $currentOpen);

    $(".submenu-item.show").addClass("removing");

    if ($(this).data("id") === $currentOpen.data("id")) {
      $menuItems.removeClass("show");

      setTimeout(() => {
        $(".submenu-item.show").removeClass("show");
        return;
      }, 100);
    } else {

      let $submenuWrapper = $(
        ".submenu-item[data-id=" + $(this).data("id") + "]"
      );
      if ($submenuWrapper.hasClass("show")) {
        $(this).removeClass("show");
        $submenuWrapper.addClass("removing");
        setTimeout(() => {
          $submenuWrapper.removeClass("removing");
          $submenuWrapper.removeClass("show");
        }, 100);
      } else {
        $submenuWrapper.addClass("showing");
        $menuItems.removeClass("show");
        $(this).addClass("show");
        setTimeout(() => {
          $(".submenu-item.show").removeClass("show");
          $submenuWrapper.addClass("show");
          $submenuWrapper.removeClass("showing");
        }, 100);
      }
    }
  },

  toggleMenuLinkXS: function () {
    let $mainDiv = $(this).parent().find(".menu-item-wrapper.submenu-xs");

    let $submenuWrapper = $(this).parent().find("ul");
    if ($submenuWrapper.hasClass("show")) {
      $submenuWrapper.addClass("removing");
      setTimeout(() => {
        $submenuWrapper.removeClass("removing");
        $submenuWrapper.removeClass("show");
        $mainDiv.removeClass("show");
      }, 100);
    } else {
      $submenuWrapper.addClass("showing");
      setTimeout(() => {
        $(".submenu-xs.show").removeClass("show");
        $submenuWrapper.addClass("show");
        $submenuWrapper.removeClass("showing");
        $mainDiv.addClass("show");
      }, 100);
    }
  },

  toggleFinder: function () {
    let $menu = $("#menuHeader");
    let $finder = $(".finder");
    let $finderIcon = $("a.js-toggleFinder");
    let $closeIcon = $(".close.js-toggleFinder");
    let $align = $(".align-right-search");

    if ($menu.hasClass("hidden")) {
      $menu.removeClass("hidden");
      $finder.removeClass("show");
      $finderIcon.removeClass("hidden");
      $closeIcon.removeClass("show");
      $align.removeClass("show");
    } else {
      $menu.addClass("hidden");
      $finder.addClass("show");
      $finderIcon.addClass("hidden");
      $closeIcon.addClass("show");
      $align.addClass("show");
    }
  },

  toggleFinderXS: function () {
    let $menu = $("#menuHeaderXS");
    let $finder = $(".finder-xs");
    let $finderIcon = $(".js-openFinderXS");
    let $hamburger = $(".hamburger-box");

    if ($hamburger.hasClass("isOpen")) {
      if (!$menu.hasClass("hidden")) {
        console.log("From menu, change div");
        $menu.addClass("hidden");
        $finder.addClass("show");
        $finderIcon.addClass("hidden");
      } else {
        console.log("Close from search open, close and reset");
        $(".js-openMenuXS").click();
        $menu.removeClass("hidden");
        $finder.removeClass("show");
        $finderIcon.removeClass("hidden");
      }
    } else {
      console.log("From anywhere, open with search");
      $(".js-openMenuXS").click();
      $menu.addClass("hidden");
      $finder.addClass("show");
      $finderIcon.addClass("hidden");
    }
  },

  executeSearch: function (e) {
    if (e.keyCode === 13) {
      let href = $(".js-searchPanelButton").prop("href");

      window.location.href = href;
    }
  },

  openMenuXS: function () {
    var classList = $(".xs-menu-wrapper").attr("class").split(/\s+/);
    var $menu = $(".xs-menu-wrapper");
    let $body = $("body");
    let $alertbar = $(".alert-bar");
    var isOpen = false;
    for (let i = 0; i < classList.length; i++) {
      let item = classList[i];
      if (item === "slide-in") {
        isOpen = true;
      }
    }
    if (isOpen) {
      let $finderIcon = $(".js-openFinderXS");
      $finderIcon.removeClass("hidden");

      $(".header").removeClass("nav-down");
      $(".hamburger-box").removeClass("isOpen");
      $menu.addClass("slide-out").removeClass("slide-in");
      $(".icon-search").removeClass("hidden");
      $body.removeClass("no-scroll");

      setTimeout(function () {
        $alertbar.removeClass("hidden");
      }, 500);
    } else {
      // Remove search bar
      let $menu_search = $("#menuHeaderXS");
      let $finder = $(".finder-xs");
      let $finderIcon = $(".js-openFinderXS");
      $menu_search.removeClass("hidden");
      $finder.removeClass("show");
      $finderIcon.removeClass("hidden");
      $(".icon-search").addClass("hidden");
      $alertbar.addClass("hidden");

      // Do funcionality
      $(".header").addClass("nav-down");
      $(".hamburger-box").addClass("isOpen");
      $menu.addClass("slide-in").removeClass("slide-out");
      $body.addClass("no-scroll");
    }
  },

  toggleResults: function () {
    let id = $(this).data("id");
    let $resultsInfo = $('.expand[data-id="' + id + '"]');
    let $resultsWrap = $('.results[data-id="' + id + '"]');
    let child = $(this).children();

    if ($resultsInfo.hasClass("open")) {
      $resultsInfo.removeClass("open");
      $resultsWrap.removeClass("open");
      child.removeClass("open");
    } else {
      $resultsInfo.addClass("open");
      $resultsWrap.addClass("open");
      child.addClass("open");
    }
  },

  toggleSubmenu: function () {
    let id = $(this).data("item-id");
    let line = $(this).data("line-id");

    let $submenu = $('.sitemap-item-submenu[data-item-id="' + id + '"]');
    let height = 0;

    let $text = $submenu.parent().find(".with-submenu").first();

    if ($submenu.hasClass("hidden")) {
      if ($(window).width() > 993) {
        $('.sitemap-item-submenu[data-line-id="' + line + '"]').addClass(
          "hidden"
        );
        let $siblingsOpen = $(
          '.js-toggleSubmenu[data-line-id="' + line + '"]'
        ).parent(".with-submenu");
        $siblingsOpen.removeClass("open");
      }

      $submenu.removeClass("hidden");
      $text.addClass("open");
      height = $submenu.outerHeight();
      if ($(window).width() > 993)
        $('.sitemap-line[data-line-id="' + line + '"]').css(
          "margin-bottom",
          height + "px"
        );
    } else {
      $submenu.addClass("hidden");
      $text.removeClass("open");
      if ($(window).width() > 993)
        $('.sitemap-line[data-line-id="' + line + '"]').css(
          "margin-bottom",
          "0"
        );
    }
  },

  popupSubmenu: function (e) {
    let id = $(this).data("item-id");
    let line = $(this).data("line-id");

    let $popup = $('.sitemap-subitem-popup[data-item-id="' + id + '"]');

    let x = e.pageX - $(this).offset().left;
    let y = e.pageY - $(this).offset().top;

    if ($popup.hasClass("open")) {
      $popup.removeClass("open");
      $popup.parent().removeClass("open");
    } else {
      $(".office-popup").removeClass("open");
      $(".sitemap-subitem-popup").removeClass("open");
      $(".sitemap-subitem").removeClass("open");
      $popup.addClass("open");
      $popup.parent().addClass("open");

      if ($(window).width() > 993)
        $popup.css({ top: y + "px", left: x + "px" });
      else $popup.css({ top: y + "px" });
    }
  },

  toggleSubmenuInside: function (e) {
    let id = $(this).data("item-id");
    let $submenu = $(
      '.submenu-children-inside-list[data-item-id="' + id + '"]'
    );
    let $text = $submenu.parent().find(".with-submenu").first();

    if ($submenu.hasClass("hidden")) {
      $submenu.removeClass("hidden");
      $text.addClass("open");
    } else {
      $submenu.addClass("hidden");
      $text.removeClass("open");
    }
  },
};

utils.scroll = {
  didScroll: false,
  lastScrollTop: 0,
  navbarHeight: $(".header-bottom").outerHeight(),
  delta: 5,

  check: function () {
    utils.scroll.didScroll = true;

    let animatableElements = $(".js-animatable:not(.isVisible)");

    let windowHeight = $(window).height() + $(window).scrollTop();
    let scrollTop = $("html").scrollTop();

    // Show normal animatable elements
    for (let i = 0; i < animatableElements.length; i++) {
      let positionFromTop = animatableElements[i].getBoundingClientRect().top;
      let delay = 0;
      if (positionFromTop - windowHeight <= 0) {
        setTimeout(function () {
          $(animatableElements[i]).addClass("isVisible");
          console.log("animatable visible", animatableElements[i]);
        }, i * 400 + delay);
      }
    }

    // Rotate elements
    let rotation = $(window).scrollTop() * 0.5;
    $(".js-scrollRotate").css({ transform: "rotate(" + rotation + "deg)" });

    // Image reveal
    $(".js-imgReveal:not(.isVisible)").each((index, img) => {
      let $img = $(img);
      let imgPosTop = $img.offset().top;
      let delay = 200;
      if (imgPosTop - windowHeight <= 0) {
        setTimeout(function () {
          $img.addClass("isVisible");
        }, index * 100 + delay);
      }
    });

    // Image opacity
    $(".js-imgOpacity:not(.isVisible)").each((index, img) => {
      let $img = $(img);
      let imgPosTop = $img.offset().top;
      let delay = 200;
      if (imgPosTop - windowHeight <= 0) {
        setTimeout(function () {
          $img.addClass("isVisible");
        }, index * 500 + delay);
      }
    });

    // Image zoom
    $(".js-imgZoom:not(.isVisible)").each((index, img) => {
      let $img = $(img);
      let imgPosTop = $img.offset().top;
      let delay = 200;
      if (imgPosTop - windowHeight <= 0) {
        setTimeout(function () {
          $img.addClass("isVisible");
        }, index * 500 + delay);
      }
    });

    setInterval(function () {
      if (utils.scroll.didScroll) {
        utils.header.hasScrolled();
        utils.scroll.didScroll = false;
      }
    }, 250);
  },
};

utils.binds = function () {
  utils.header.binds();
  utils.scroll.check();

  $(".js-closeCookies").on("click", function () {
    $(".banner-cookies").addClass("hide");
    setTimeout(function () {
      $(".banner-cookies").css("display", "none");
    }, 350);
  });

  $(document).on("scroll", utils.scroll.check);
};

utils.init = function () {
  utils.header.init();
  console.log("utils init");
};

$(document).ready(function () {
  utils.binds();
  utils.init();
});
